module.exports = __webpack_public_path__ + "img/icon100.c91c09e9.png";